import React, { ReactNode } from 'react';
import { Avatar } from 'shared/ui/Avatar';

import { statusColorHandle } from '../DemandWidget.libs';
import styles from '../DemandWidget.module.scss';
import { DataType } from '../DemandWidget.types';

const getDemandDataCell = ({
  accountLogo,
  accountName,
  demandStatus,
  positionName,
}: DataType['demandData']): ReactNode => {
  return (
    <div className={styles.demandLogoStatus}>
      <span className={styles.demandStatus} style={{ backgroundColor: statusColorHandle(demandStatus) }} />
      <Avatar picture={accountLogo} text={accountName} size={24} className={styles.avatar} />
      <span className={styles.demandWidgetText}>{positionName}</span>
    </div>
  );
};

export default getDemandDataCell;
